export default __webpack_public_path__ + "static/media/liquidity.3a2d42db.svg";